import * as React from "react";
import { useNavigate } from "react-router-dom";
import { DataStatus } from "../CommonComps/DataStatus";
import {
  StyledTableCell,
  StyledTableRow,
  checkPermissionExist,
} from "../utils/index";
import { Editedtext, EditedtextCode } from "../CommonComps/TextTemplate";
import {
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography,
  Paper,
} from "@mui/material";
import moment from "moment";
import HistoryIcon from "@mui/icons-material/History";
import { useSelector } from "react-redux";
import {
  singleAccountUrl,
  singleTransactionGetUrl,
  taxConfigurationEndpoint,
} from "../config";
import AmountInfo from "../CommonComps/AmountInfo";
const rightAlign = { textAlign: "right" };
const headers = [
  { id: 1, name: "S.No" },
  { id: 2, name: "Name" },
  { id: 3, name: "Tax Type" },
];

function Row({ row, index }) {
  const endPoints = useSelector(
    (val) => val?.rootReducer?.permissionReducer?.data
  );
  const { name, taxType } = row;
  const navigate = useNavigate();

  const handleEditCategory = (row) =>
    navigate("/addAccount", { state: row.id });

  return (
    <React.Fragment>
      <StyledTableRow>
        <StyledTableCell style={{ paddingLeft: 10 }}>
          <Typography variant="body2" style={{ paddingLeft: 10 }}>
            {index}{" "}
          </Typography>
        </StyledTableCell>

        <StyledTableCell>
          <Editedtext text={name} num="30" />{" "}
        </StyledTableCell>

        <StyledTableCell>
          <Editedtext text={taxType} num="30" />{" "}
        </StyledTableCell>

        {/* <StyledTableCell style={{ textAlign: "right" }}>
          <IconButton
            style={{
              visibility: checkPermissionExist(
                endPoints,
                singleTransactionGetUrl
              )
                ? "visible"
                : "hidden",
            }}
            name={name}
            onClick={() => {
              checkPermissionExist(endPoints, taxConfigurationEndpoint) &&
                navigate("/tax-configuration/tax-section", { state: row });
            }}
          >
            <HistoryIcon
              style={{
                color: "green",
                visibility: checkPermissionExist(
                  endPoints,
                  taxConfigurationEndpoint
                )
                  ? "visible"
                  : "hidden",
              }}
            />
          </IconButton>
        </StyledTableCell> */}
      </StyledTableRow>
    </React.Fragment>
  );
}

export default function TdsTable({ taxData }) {
  return (
    <>
      <TableContainer
        component={Paper}
        style={{ marginTop: 20, maxHeight: "calc(100vh - 300px)" }}
      >
        <Table aria-label="collapsible table" stickyHeader>
          <TableHead>
            <StyledTableRow>
              {headers &&
                Array.isArray(headers) &&
                headers.length > 0 &&
                headers.map((val) => (
                  <StyledTableCell style={val.style} key={val.id}>
                    {val.name}
                  </StyledTableCell>
                ))}
            </StyledTableRow>
          </TableHead>

          <TableBody>
            {taxData &&
              taxData.map((row, index) => (
                <Row key={row.id} row={row} index={index + 1} />
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {taxData && taxData.length < 1 && <DataStatus />}
    </>
  );
}
